export default axios => ({
  getSettings: () => axios.get('settings').then(r => r.data || {})
})
